/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
import { motion } from 'framer-motion';
import React from 'react';

function ExportModal({
    exportClick, setexportClick, subMenuAnimate, setexportSelected, csv, pdf, excel,
}) {
    return (
        <div className="pl-2 dropdown relative mb-4">
            <button
                onClick={() => {
                    setexportClick(!exportClick);
                }}
                type="button"
                id="exportDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] px-9 border border-[#555259] rounded-lg"
            >
                Export
            </button>
            <motion.ul
                initial={false}
                animate={exportClick ? 'enter' : 'exit'}
                variants={subMenuAnimate}
                className={`dropdown-menu min-w-[140px] absolute 
                         ${exportClick ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`}
                aria-labelledby="exportDropdown"
            >
                <li
                    className="px-5 pb-1.5 pt-5"
                    onClick={() => setexportSelected(csv)}
                >
                    <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)">CSV</a>
                </li>
                <li
                    className="px-5 py-1.5"
                    onClick={() => setexportSelected(pdf)}
                >
                    <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)">PDF</a>
                </li>
                <li
                    className="px-5 pt-1.5 pb-5"
                    onClick={() => setexportSelected(excel)}
                >
                    <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)">Excel</a>
                </li>
            </motion.ul>
        </div>
    );
}

export default ExportModal;
